"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDebugQueryParamPresent = exports.DEBUG_QUERY_PARAM = exports.DEBUG_PREFIX = void 0;
const DEBUG_QUERY_PARAM = 'rumdebug';
exports.DEBUG_QUERY_PARAM = DEBUG_QUERY_PARAM;
const DEBUG_PREFIX = `[${DEBUG_QUERY_PARAM}]`;
exports.DEBUG_PREFIX = DEBUG_PREFIX;
/**
 * Return if the debug query param is present or not.
 *
 * @note This should be called **only once per session** so we don't keep
 *   creating a bunch of new `URLSearchParams`
 * @returns {boolean} if the debug query param is present or not
 * @private
 */
const isDebugQueryParamPresent = () => {
    var _a;
    // Bail if we're not in a browser environment. See PERF-802.
    if (typeof window === 'undefined')
        return false;
    const query = (_a = window.location) === null || _a === void 0 ? void 0 : _a.search;
    return Boolean(query &&
        typeof URLSearchParams !== 'undefined' &&
        new URLSearchParams(query).get(DEBUG_QUERY_PARAM) !== null);
};
exports.isDebugQueryParamPresent = isDebugQueryParamPresent;
/** Debug class for determining if debug mode is enabled and debug logging */
class Debug {
    /**
     * Creates a new Debug instance. Optionally accepts an alternate function to
     * use to check if a debug flag is present which is useful for testing.
     * (Defaults to `isDebugQueryParamPresent()`.)
     */
    constructor(isDebugFlagTestFn = isDebugQueryParamPresent) {
        this.isDebugFlag = isDebugFlagTestFn();
    }
    /**
     * Returns if debug mode is enabled or not based on the presence of the
     * `DEBUG_QUERY_PARAM` in the query string of the URL.
     *
     * @note The presence of the query param is only checked once at the
     *   beginning of the session, so the page will need to be reloaded to
     *   enable/disable debug mode.
     */
    isEnabled() {
        return this.isDebugFlag;
    }
    /**
     * Logs a debug-level message to the console if is debug mode is enabled
     * using `console.debug`. Messages will be prefixed with the
     * `DEBUG_QUERY_PARAM` for easy filtering.
     *
     * @param  {...any} args - A debug message and anything else you want logged
     *   to the console at the debug level. All `args` are passed directly to
     *   `console.debug()`.
     */
    log(...args) {
        if (!this.isEnabled())
            return;
        console.debug(DEBUG_PREFIX, ...args);
    }
}
exports.default = Debug;
